import { Box, Card, styled } from "@mui/material";

export const MapContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  "& .maplibregl-ctrl-geocoder": {
    maxWidth: "400px",
    width: "95vw",
    fontFamily: "Roboto, Arial, sans-serif",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    borderRadius: "2px !important",
    border: "none !important",
    backgroundColor: "white",
    marginTop: "10px",
    marginLeft: "10px",
  },
  "& .maplibregl-ctrl-geocoder--input": {
    height: "48px",
    padding: "12px 50px",
    fontSize: "15px",
    color: "#333",
  },
  "& .maplibregl-ctrl-geocoder--icon-search": {
    top: "13px",
    left: "12px",
  },
  "& .maplibregl-ctrl-geocoder--icon-close": {
    right: "12px",
    top: "13px",
  },
  "& .maplibregl-ctrl-geocoder--button": {
    backgroundColor: "transparent",
  },
  "& .maplibregl-ctrl-geocoder--results": {
    marginTop: "1px",
    borderRadius: "0 0 2px 2px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
  },
  "& .maplibregl-ctrl-geocoder--result": {
    padding: "8px 15px",
    fontSize: "14px",
    borderBottom: "1px solid #eee",
  },
  "& .maplibregl-ctrl-geocoder--result-title": {
    fontWeight: "500",
  },
}));

export const LocationCard = styled(Card)(({ theme }) => ({
  position: "absolute",
  bottom: "80px",
  left: "50%",
  transform: "translateX(-50%)",
  width: "340px",
  zIndex: 3,
  backgroundColor: "#ffffff",
  boxShadow: "0 1px 4px rgba(0,0,0,0.16), 0 2px 10px rgba(0,0,0,0.12)",
  borderRadius: "8px",
  overflow: "hidden",
  "& .MuiCardContent-root": {
    padding: "16px",
    backgroundColor: "#ffffff",
    position: "relative",
  },
  "& .MuiTypography-h6": {
    color: "#202124",
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.4,
    margin: 0,
  },
  "& .MuiTypography-body1": {
    color: "#333333",
    fontSize: "0.875rem",
  },
  "& .MuiSelect-select": {
    backgroundColor: "#ffffff",
    color: "#333333",
  },
  "& .MuiFormControlLabel-label": {
    color: "#333333",
  },
  "& .MuiMenuItem-root": {
    color: "#333333",
  },
  "& .MuiFormControl-root": {
    marginBottom: "12px",
  },
  "& .MuiCardActions-root": {
    padding: "8px 16px",
    justifyContent: "flex-end",
    borderTop: "1px solid #e8eaed",
  },
  "& .MuiInputLabel-root": {
    color: "#5f6368",
  },
  "& .MuiButton-contained": {
    textTransform: "none",
    boxShadow: "none",
    fontWeight: 500,
    padding: "6px 16px",
  },
}));
